import { CHANGE_TYPE_TO_UI_TEXT } from "../constants";
export const getChangeFileName = (change) => change.origin.file_path.split("/").at(-1) || change.origin.file_path;
export const filterReproChanges = (changes, { search, changeTypes }) => {
    const query = search.trim().toLowerCase();
    return changes.filter((change) => {
        if (changeTypes.length > 0 && !changeTypes.includes(change.changed_object))
            return false;
        if (query.length === 0)
            return true;
        const haystack = [
            CHANGE_TYPE_TO_UI_TEXT[change.changed_object],
            change.origin.file_path,
            change.diff_change.previous,
            change.diff_change.current,
        ]
            .join(" ")
            .toLowerCase();
        return haystack.includes(query);
    });
};
export const sortReproChanges = (changes, { reverse }) => {
    const direction = reverse ? -1 : 1;
    return [...changes].sort((first, second) => CHANGE_TYPE_TO_UI_TEXT[first.changed_object].localeCompare(CHANGE_TYPE_TO_UI_TEXT[second.changed_object]) * direction);
};
//# sourceMappingURL=utils.js.map